import Divider from '@portalterreno/react-ui-core/Divider';
import { FC, Fragment } from 'react';

import Badge, { BadgeProps } from './Badge';
import Wrapper from './Wrapper';

export type BadgesListProps = {
  badges: Array<BadgeProps>;
};

const BadgesList: FC<BadgesListProps> = ({ badges }) => {
  return (
    <Fragment>
      <Divider />
      <Wrapper>
        {badges.map((badge) => {
          return (
            <Badge
              key={badge.name}
              {...badge}
            />
          );
        })}
      </Wrapper>
    </Fragment>
  );
};

export default BadgesList;
